import React,{ useEffect,useState } from 'react';
import ReactDOM from 'react-dom';

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import "./SingleLevel.css";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
const SingleLevel = ({ item }) => {

   const [camData,setCamData] = useState("");
   var animTime = 1;
   var cameraType = null;
   const handlecameraClick = (divname,itemtype,sequenceName) => {  
      var menuTitle =  window.removeTags(item.title);
      console.log(menuTitle,  window.configProduct.name);      
      window.RT_RecordEvent(menuTitle,  window.configProduct.name);
       window.soundViewClick = false;
       clearTimeout(window.clearTime);
       var tex = window.scene._Texture_ref["Laptop_Screen_Video_mode.png"];
       var texture = window.scene._Textures[tex.tex_id];
       if (texture != null) {
          var gl = window.scene.gl;
          gl.bindTexture(gl.TEXTURE_2D,texture);
          gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
          gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage2);
       }
 
       window.playVideo = false;
       window.isMobileActive = false;
       window.sharpClickNav = false;
         if(document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "none";
         if(document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";
         if (document.getElementById("auraedition_logo") != undefined) document.getElementById("auraedition_logo").style.display = "none";
      
      window.scene._nav._fRotMinLimitConst = 0.3;
      window.scene._nav.SetRotationCenter([0,0,0]);
      if(document.getElementById("intel_ultra_logo") != undefined) document.getElementById("intel_ultra_logo").style.display = "none";
      window.hideAllPopup();
      window.fRotMinLimitVal = 0.02;
      window.updateNavigation(divname);
      window.resetpop();
      setTimeout(() => {
         window.menuHeightCalaulate()         
      }, 200);
      let currentActivePopup = document.querySelector('.content.currentActivePopup');
      let currentActiveHotspot = document.querySelector('.hotspots.currentActiveHotspot');
      if(currentActiveHotspot != null) currentActiveHotspot.classList.remove('currentActiveHotspot');
      if(currentActivePopup != null) currentActivePopup.classList.remove('currentActivePopup');
      let currentActivesinglePopup  = document.querySelector('.singlePopup.active');
      if(currentActivesinglePopup != null) currentActivesinglePopup.classList.remove('active');

      let hotspotsActive = [...document.querySelectorAll(".hotspots")];
      hotspotsActive.forEach(ele => {
            ele.style.display = "none";
      });
      window.currentPosition = '';


      if (window.mob) {
         window.scene._bDoF = false;
      } else {
         window.scene._bDoF = false;
      }
     
      if (itemtype !== 'Skins') {
         if (window.functionClick) return false;
         window.functionClick = true;   
         if (!divname) {
            return false;
         }
         if (window.menuClick == false) {
            return false;
         }
         var isActive = document.getElementById(divname)
         if (isActive.classList.contains('active')) {
            if (window.mob || (window.isipad && window.innerHeight > window.innerWidth)) {
               document.getElementById(divname).classList.remove('active');
            }
         }
         else {
            const collection = document.getElementsByClassName("menu");
            for (let i = 0; i < collection.length; i++) {
               collection[i].classList.remove('active');
            }
            document.getElementById(divname).classList.add('active');
         }

         if (window.mob || window.isipad || window.innerWidth < 818 || window.innerHeight < 818) {
            const arrow = document.getElementsByClassName("content1");
            for (let i = 0; i < arrow.length; i++) {
               if (arrow[i].getAttribute('id') !== "content1-" + divname + "") {
                  arrow[i].style.maxHeight = null
               }
            }
            var content = document.getElementById("content1-" + divname + "");
            if (content.style.maxHeight) {
               content.style.maxHeight = null;
            } else {
               content.style.maxHeight = "100%";
            }
         }

         //console.log((divname)

         if (divname === "Render_Cam_Performance_F220") {
            cameraType = 'Performance';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Performance_F220) }
            else { window.Render_Cam_Performance_F220() }
            window.selectedMenu.active = 'Render_Cam_Performance_F220';
         }

         else if (divname === "Render_Cam_Aura_Edition_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Aura_Edition_F50) }
            else { window.Render_Cam_Aura_Edition_F50() }
            window.selectedMenu.active = 'Render_Cam_Aura_Edition_F50';
         }

         else if (divname === "Render_Cam_Smart_Share_F48") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Smart_Share_F48) }
            else { window.Render_Cam_Smart_Share_F48() }
            window.selectedMenu.active = 'Render_Cam_Smart_Share_F48';
         }

         else if (divname === "Reset_View_F14") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Reset_View_F14) }
            else { window.Reset_View_F14() }
            window.selectedMenu.active = 'Reset_View_F14';
         }
         else if (divname === "Render_Cam_Smart_Care_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Smart_Care_F50) }
            else { window.Render_Cam_Smart_Care_F50() }
            window.selectedMenu.active = 'Render_Cam_Smart_Care_F50';
         }
         else if (divname === "Render_Cam_Sustainable_Material_F180_Zoom_Reg") {
            cameraType = 'interiorsustainablematerial';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Sustainable_Material_F180_Zoom_Reg) }
            else { window.Render_Cam_Sustainable_Material_F180_Zoom_Reg() }
            window.selectedMenu.active = 'Render_Cam_Sustainable_Material_F180_Zoom_Reg';
         }
         else if (divname === "Render_Cam_Smart_Mode_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Smart_Mode_F50) }
            else { window.Render_Cam_Smart_Mode_F50() }
            window.selectedMenu.active = 'Render_Cam_Smart_Mode_F50';
         }
         else if (divname === "Render_Cam_Right_Port_F50_Reg") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Right_Port_F50_Reg) }
            else { window.Render_Cam_Right_Port_F50_Reg() }
            window.selectedMenu.active = 'Render_Cam_Right_Port_F50_Reg';
         }
         else if (divname === "Render_Cam_Thin_Light_02_F115") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Thin_Light_02_F115) }
            else { window.Render_Cam_Thin_Light_02_F115() }
            window.selectedMenu.active = 'Render_Cam_Thin_Light_02_F115';
         }
         else if (divname === "Render_Cam_F145_Intel_Chip") {
            cameraType = 'intelchip';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F145_Intel_Chip) }
            else { window.Render_Cam_F145_Intel_Chip() }
            window.selectedMenu.active = 'Render_Cam_F145_Intel_Chip';
         }
         else if (divname === "Render_Cam_Battery_F145") {
            cameraType = 'interiorbattery';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Battery_F145) }
            else { window.Render_Cam_Battery_F145() }
            window.selectedMenu.active = 'Render_Cam_Battery_F145';
         }
       
         sequenceName && window.scene.applySequence(window[sequenceName]);   
         // console.log(item.cameraName, "camera")
         // GotoPosInTimeNamedValue(item.cameraName,function () {
         //    window.selectedMenu.cameraType = cameraType;
         //    window.fadeOut();          
         // });
         
      } else {
         const collection = document.getElementsByClassName("skin_menu");
         document.getElementById("Skins").classList.remove('MuiCollapse-hidden');
         document.getElementById("Skins").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Skins").previousSibling.classList.add('menuActive');
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }
         window.changeSkin(divname);
      }
      
      setTimeout(function(){
         window.updateZoomSliderUIOnly(window.sliderEl3, window.scene._nav.getZoomFactor());
      },2000);
      window.calloutPositionReset();

   }
   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname, onComplete, onSample) => {
      // alert("111")
      let zoomResize = window.setZoomReset();
      var opt = undefined;
      if (!(window.mob || window.isipadPortrait)) {
         var gp = camData[gotoposname];
      } else {
         // var gp = camData[gotoposname];
         var gp = camData[gotoposname + '_Mob'];
         // if (gotoposname == 'Reset_View_F14_EVO') { 
         //    zoomResize = -80;
         // }
         // else if (gotoposname == 'Render_Cam_F50_Camera_Zoom') {
         //    zoomResize = -15;
         // }
         // else {
         //           zoomResize = -35;
         // }
      }
      if (gp.fovy && window.scene.fovy !== gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      gp.time = animTime;
      console.log(zoomResize)
      window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + zoomResize, 2000, onComplete, slowinout2, opt);
   }
   function slowinout2(x) {
      var a = 4.0;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);
      return px / (px + px2);
   }
   
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);
   
      return px / (px + px2);
   }
   const GetData = async () => {

      await fetch('model_gl/config.json'
         ,{
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      ).then((response) => response.json())
         .then((myJson) => {
            setCamData(myJson.positions);
         })         
   }
   useEffect(() => {
      GetData();
   },[]);

   return (
      item.type !== 'Skins' ? <div className={`menu`} id={item.id}>
         <ListItem button className='collapsible' onClick={() => { handlecameraClick(item.id,item.type,item.sequenceName) }}>
            <div className='accordia_icon'>
               <img className='arrow' src='img/spacer.png' id={`accordianIcon_${item.id}`} />
            </div>
            {/* <ListItemText primary={item.title} /> */}
            {
               <div className="MuiListItemText-root"><span className="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock">{ ReactHtmlParser(item.title) }</span></div>
            }
         </ListItem>
         {ReactDOM.createPortal(
         <>
            {item.content && item.content.map((child, key) => (
                  <div key={key} className='calloutbox font28 calloutbox_white' data-id={child.dataId} id={child.dataId+'_popupJSON'}>
                     <h3>
                        {/* {child.heading} */}
                        { ReactHtmlParser(child.heading) }
                     </h3>
                     {child.subheading !== undefined && 
                     <h4>
                        {/* {child.heading} */}
                        { ReactHtmlParser(child.subheading) }
                     </h4>
                     }
                     <div className='content'>
                        <div>
                           <ul className='listItem1'>
                                 <li>
                                 {/* {child.text} */}
                                 { ReactHtmlParser(child.text) }
                                 </li>
                                 {child.content2  && <ul>
                                    {child.content2 && child.content2.map((content2, key) => {
                                       return (
                                          <li  key={key} className='submenutext'>{content2}</li>
                                       )
                                    })
                                    }
                                 </ul> }

                              </ul>
                          
                        {child.text1 !== undefined &&
                        <ul className='listItem1'>
                           <li>
                              {/* {child.text2} */}
                              { ReactHtmlParser(child.text1) }
                           </li>
                        </ul>
                        }                         
                        {child.text2 !== undefined &&
                        <ul className='listItem2'>
                           <li>
                              {/* {child.text2} */}
                              { ReactHtmlParser(child.text2) }
                           </li>
                        </ul>
                        } 
                        </div>                        
                        {child.text3 !== undefined &&
                           <ul className='listItem3'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text3) }
                              </li>
                           </ul>
                        }
                        {child.text4 !== undefined &&
                           <ul className='listItem4'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text4) }
                              </li>
                           </ul>
                        }
                        {child.text5 !== undefined &&
                           <ul className='listItem5'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text5) }
                              </li>
                           </ul>
                        }
                        {child.text6 !== undefined &&
                           <ul className='listItem6'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text6) }
                              </li>
                           </ul>
                        }
                        {child.text7 !== undefined &&
                           <ul className='listItem7'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text7) }
                              </li>
                           </ul>
                        }
                        {child.text8 !== undefined &&
                           <ul className='listItem8'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text8) }
                              </li>
                           </ul>
                        }
                        {child.text9 !== undefined &&
                           <ul className='listItem9'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text9) }
                              </li>
                           </ul>
                        }
                        {child.text10 !== undefined &&
                           <ul className='listItem10'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text10) }
                              </li>
                           </ul>
                        }
                        {child.text11 !== undefined &&
                           <ul className='listItem11'>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text11) }
                              </li>
                           </ul>
                        }
                        {child.vproicon !== undefined &&
                           <img className={`vpro_logo`} src={child.vproicon} />
                        }
                         {child.intelicon !== undefined &&
                           <img className={`intel_logo`} src={child.intelicon} />
                        }
                         {child.intelcoreicon !== undefined &&
                           <img className={`intel_core_logo`} src={child.intelcoreicon} />
                        }
                         {child.intelcoreiconwith7 !== undefined &&
                           <img className={`intel_core_logo`} src={child.intelcoreiconwith7} />
                        }
                        {(child.bottomBtn1 != undefined && child.bottomBtn2) && <div id="penButtondiv">
                           <div id={child.bottomBtn1.id} className={child.bottomBtn1.classList}>{child.bottomBtn1.text} </div>
                           <div id={child.bottomBtn2.id} className={child.bottomBtn2.classList}>{child.bottomBtn2.text} </div>
                        </div>
                        }
                         {(child.videoBtn != undefined && child.soundBtn) && <div id="soundvideoDiv">
                           <div id={child.videoBtn.id} className={child.videoBtn.classList}>{child.videoBtn.text} </div>
                           <div id={child.soundBtn.id} className={child.soundBtn.classList}>{child.soundBtn.text} </div>
                        </div>
                        }
                     </div>
                  </div>
               ))
               }
         </>, document.getElementById('calloutContainer')
         )}
         <div className="content1" id={`content1-${item.id}`}>
            <div id={`hotspot_${item.id}`}>

               {item.content && item.content.map((child,key) => (
                  <div key={key} className='popuptogglebtn' data-id={child.dataId}>
                     <p>
                        {/* {child.heading} */}
                        { ReactHtmlParser(child.heading) }
                     </p>
                     {child.subheading !== undefined &&
                        <p className='subheading'>
                          {/* {child.heading}   */}
                           {ReactHtmlParser(child.subheading)}
                        </p>
                     }
                     <h5 className='listItem1'>
                        {/* {child.text} */}
                        { ReactHtmlParser(child.text) }
                        <ul>
                           {child.content2 && child.content2.map((content2, key) => {
                              return (
                                 <li key={key} className='submenutext'>{content2}</li>
                              )
                           })
                           }
                        </ul>

                     </h5>
                     { child.text1 !== undefined && 
                        <h5 className='listItem2'>
                        {/* {child.text2} */}
                        { ReactHtmlParser(child.text1) }
                        </h5>
                     }  
                       { child.text2 !== undefined && 
                        <h5 className='listItem3'>
                        {/* {child.text2} */}
                        { ReactHtmlParser(child.text2) }
                        </h5>
                     }  
                     { child.text3 !== undefined && 
                        <h5 className='listItem4'>
                        {/* {child.text3} */}
                        { ReactHtmlParser(child.text3) }
                        </h5>
                     } 
                     { child.text4 !== undefined && 
                        <h5 className='listItem5'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text4) }
                        </h5>
                     }  
                     { child.text5 !== undefined && 
                        <h5 className='listItem6'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text5) }
                        </h5>
                     }  
                     { child.text6 !== undefined && 
                        <h5 className='listItem7'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text6) }
                        </h5>
                     }  
                      { child.text7 !== undefined && 
                        <h5 className='listItem8'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text7) }
                        </h5>
                     } 
                      { child.text8 !== undefined && 
                        <h5 className='listItem9'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text8) }
                        </h5>
                     } 
                      { child.text9 !== undefined && 
                        <h5 className='listItem10'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text9) }
                        </h5>
                     } 
                      { child.text10 !== undefined && 
                        <h5 className='listItem11'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text10) }
                        </h5>
                     } 
                      { child.text11 !== undefined && 
                        <h5 className='listItem12'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text11) }
                        </h5>
                     } 
                     {child.vproicon !== undefined && 
                     <img className={`vpro_logo_mob`} src={child.vproicon} />
                     }      
                     {child.intelicon !== undefined &&
                       <img className={`intel_logo_mob`} src={child.intelicon} />
                    }
                      {child.intelcoreicon !== undefined &&
                        <img className={`intel_core_logo_mob`} src={child.intelcoreicon} />
                     }     
                         {child.intelcoreiconwith7 !== undefined &&
                        <img className={`intel_core_logo_mob`} src={child.intelcoreiconwith7} />
                     }      
                      {/* {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'Render_Cam_Smart_Care_F50' ? <div id="penButtondiv">
                        <div id="left_port" className="active">Left Port </div>
                        <div id="right_port" className="">Right Port </div>
                     </div>
                        : ''}   */}
                        
                        {/* {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'immersive_sound_and_video' ? <div id="soundvideoDiv">
                        <div id="video_port" className="active">Video </div>
                        <div id="sound_port" className="">Sound </div>
                     </div>
                        : ''}   */}
                  </div>
               ))
               }
              
            </div>
         </div>
      </div>
         : <div className={`skin_menu`} id={item.id}>
            <ListItem button onClick={() => { handlecameraClick(item.id,item.type,item.sequenceName) }} title={item.name}>
               <div className='skin_icon'>
                  <img className='' src={item.icon} />
               </div>
            </ListItem>
         </div>
   );
};
export default SingleLevel